export default {
    state: {
        slides: [],
    },
    getters: {
        slidesByWalkthroughId: (state) => (walkthroughId) => {
            const slides = state.slides[walkthroughId]
            if (!slides) {
                return []
            }

            return slides.toSorted((a, b) => a.order_number > b.order_number)
        }
    },
    mutations: {
        setWalkthroughSlides(state, payload) {
            const {walkthroughId, slides} = payload
            this._vm.$set(state.slides, walkthroughId, slides)
        },
        updateWalkthroughSlide(state, payload) {
            const {walkthroughId, id} = payload
            const index = state.slides[walkthroughId].findIndex((slide) => id === slide.id)
            if (index !== -1) {
                state.slides[walkthroughId].splice(index, 1, payload)
            }
        },
        removeWalkthroughSlide(state, payload) {
            const {walkthroughId, id} = payload
            const slideFilter = (slide) => slide.id !== id
            const updatedSlides = state.slides[walkthroughId].filter(slideFilter)
            this._vm.$set(state.slides, walkthroughId, updatedSlides)
        },
    },
    actions: {
        async getWalkthroughSlides(context, walkthroughId) {
            const response = await this._vm.axios.get(`/api/walkthrough/${walkthroughId}`)

            const payload = {
                walkthroughId,
                slides: response.data,
            }
            context.commit('setWalkthroughSlides', payload)
        },
        async addMediaSlide(context, payload) {
            const {walkthroughId, mediaData} = payload
            const url = `/api/walkthrough/${walkthroughId}/media`

            await this._vm.axios.post(url, mediaData)
        },
        async addQuestionSlide(context, payload) {
            const {walkthroughId, questionData} = payload
            const url = `/api/walkthrough/${walkthroughId}/question`

            await this._vm.axios.post(url, questionData)
        },
        async updateSlide(context, payload) {
            const {
                title,
                description,
                alt,
                caption,
                credit,
                splash_url,
                teacher_only,
                teacher_guide,
                slide_title_enabled,
                slide_title,
                id,
            } = payload
            const url = `/api/walkthrough/slide/${id}`
            await this._vm.axios.patch(
                url,
                {
                    title,
                    description,
                    alt,
                    caption,
                    credit,
                    splash_url,
                    teacher_only,
                    teacher_guide,
                    slide_title_enabled,
                    slide_title,
                }
            )
            context.commit('updateWalkthroughSlide', payload)
        },
        async updateQuestion(context, payload) {
            const {question} = payload
            await this._vm.axios.post(`/api/questions/update/${question.id}`, {
                content: question.content,
                standards: question.standards,
            })
            context.commit('updateWalkthroughSlide', payload)
        },
        async removeWalkthroughSlide(context, payload) {
            const {id} = payload
            const url = `/api/walkthrough/slide/${id}`

            await this._vm.axios.delete(url)
            context.commit('removeWalkthroughSlide', payload)
        },
        async updateSlidePositions(context, payload) {
            const {slides} = payload
            const url = `/api/walkthrough/slides/position`
            const mappedSlides = slides.map((slide) => ({id: slide.id, order_number: slide.order_number}))

            await this._vm.axios.patch(url, {slides: mappedSlides})
        }
    }
}
